import type { ReactElement } from 'react';
import { Navigate, useParams } from 'react-router';
import ProductKeywordsUpload from '../pages/Keywords/subPages/ProductKeywordsUpload';
import KeywordsUpload from '../pages/Keywords/subPages/KeywordsUpload';
import KeywordCategoriesUpload from '../pages/Keywords/subPages/KeywordCategoriesUpload';
import TitleSplitUpload from 'pages/ProductTitles/subPages/TitleSplitUpload';
import AliasesUpload from 'pages/ProductTitles/subPages/AliasesUpload';
import { useGetUserInfoSelector } from 'core/redux/selectors/authSelectors';
import * as productManagement from 'pages/ProductManagement';
import * as keywordManagement from 'pages/Keywords';
import KeywordsByRetailersUpload from 'pages/Keywords/subPages/KeywordsByRetailerUpload';
import GlobalCategoriesUpload from 'pages/Preferences/subPages/GlobalCategoriesUpload';
import ClusterUpload from 'pages/ClusterManagement/ClusterUpload';
import UnauthorizedAccess from 'pages/UnauthorizedAccess';

const UploadRouter = () => {
    const { page } = useParams();
    const userInfo = useGetUserInfoSelector();
    const redirectReadonlyKeyword = (component: ReactElement, page: string) => {
        const readonly = !userInfo?.user_groups?.includes(18);

        if (readonly) {
            return <Navigate to={`/${keywordManagement.PATH}/${page}`} replace />;
        }

        return component;
    };

    const redirectReadonlyTitle = (component: ReactElement, page: string) => {
        const readonly = !userInfo?.user_groups?.includes(20);

        if (readonly) {
            return <Navigate to={`/${productManagement.PATH}/${page}`} replace />;
        }

        return component;
    };

    switch (page) {
        case 'keywords':
        case 'search':
        case 'banner':
            return redirectReadonlyKeyword(<KeywordsUpload />, page);
        case 'ean-keywords':
            return redirectReadonlyKeyword(<ProductKeywordsUpload />, page);
        case 'keywords-categories':
            return redirectReadonlyKeyword(<KeywordCategoriesUpload />, page);
        case 'keywords-by-retailers':
            return redirectReadonlyKeyword(<KeywordsByRetailersUpload />, page);
        case 'splits':
            return redirectReadonlyTitle(<TitleSplitUpload />, page);
        case 'global-categories':
            return redirectReadonlyKeyword(<GlobalCategoriesUpload />, page);
        case 'aliases':
            return redirectReadonlyTitle(<AliasesUpload />, page);
        case 'cluster':
        case 'shop-cluster':
        case 'product-cluster':
            return <ClusterUpload page={page} />;
    }

    return <UnauthorizedAccess />;
};

export default UploadRouter;
